import React, { Component } from 'react';

import Breakpoints from 'lib/Breakpoints';
import ChildrenPropType from 'lib/CustomPropTypes/children';
import scrollWindowTo from 'lib/scrollToElement';

import InternalPanelList from './InternalPanelList';
import InternalPanelListItem from './InternalPanelListItem';
import InternalTabList from './InternalTabList';
import InternalTabListItem from './InternalTabListItem';

class TabbedContent extends Component {
  static propTypes = {
    children: ChildrenPropType.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      activePanelIndex: 0,
    };

    this.handleTabClick = this.handleTabClick.bind(this);
  }

  handleTabClick(activePanelIndex) {
    this.setState({
      activePanelIndex,
    });

    const currentYPositionOfWindow = window.scrollY;
    let yPositionOfStickyTabs;
    if (Breakpoints.isS()) {
      yPositionOfStickyTabs = 50;
    } else {
      yPositionOfStickyTabs = 197;
    }

    if (currentYPositionOfWindow > yPositionOfStickyTabs) {
      scrollWindowTo(yPositionOfStickyTabs);
    }
  }

  render() {
    const { activePanelIndex } = this.state;
    const { children } = this.props;

    const panels = children.map((child, index) => ({
      panelID: index,
      tabText: child.props.tabText,
      children: child.props.children,
    }));

    return (
      <div className="tabbed-content">
        <InternalTabList>
          {panels.map((panel) => {
            const { panelID, tabText } = panel;
            const isActive = (panelID === activePanelIndex);

            return (
              <InternalTabListItem
                key={panelID}
                active={isActive}
                onClick={() => this.handleTabClick(panelID)}
                text={tabText}
              />
            );
          })}
        </InternalTabList>

        <InternalPanelList>
          {panels.map((panel) => {
            const { children: panelChildren, panelID } = panel;
            const isActive = (panelID === activePanelIndex);

            return (
              <InternalPanelListItem
                key={panelID}
                show={isActive}
              >
                { panelChildren}
              </InternalPanelListItem>
            );
          })}
        </InternalPanelList>
      </div>
    );
  }
}

export default TabbedContent;
